import { createContext } from 'react';
var ChatContext = createContext({});
export default ChatContext;
